//bao migrate skip
import template from "./tooltip.html";
import * as Tooltip from "./tooltip-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e: HTMLElement = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new Tooltip.BaoTooltip(params, e, componentInfo.templateNodes);
            return vm;
        }
    },
    template: template
};